import { render, staticRenderFns } from "./UsersRole.vue?vue&type=template&id=36a0e788&scoped=true"
import script from "./UsersRole.vue?vue&type=script&lang=js"
export * from "./UsersRole.vue?vue&type=script&lang=js"
import style0 from "./UsersRole.vue?vue&type=style&index=0&id=36a0e788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0e788",
  null
  
)

export default component.exports